<template>
  <span class="custom">
    <!--
    <select v-model="selected" :name="sel_name">
      <option v-for="o in opt" :value="o.value">{{ o.text }}</option>
    </select> -->
    <s-select :el="el.firstElementChild" v-model="selected" custom="true"></s-select>
    <blockquote v-show="blockquoteShow">
      <!-- transition-group name="bounce" -->
	<div v-for="c in custom" v-if="selected == c.value" :key="c.value">
          <simple-element :el="c.el"></simple-element>
	</div>
      <!-- /transition-group -->
    </blockquote>
  </span>
</template>
    
<script>
var $ = require('jquery')

export default {
    name: 'custom-select',
    props: ['el'],
    data() {
	return {
	    selected: '',
	    /*
	    opt: [{
		value: '',
		text: ''
	    }],
	    */
	    custom: [{
	    	value: '',
		el: ''
	    }],
	    //blockquoteShow: false
	}
    },
    computed: {
	sel_name: function() {
	    //console.log(this.el.firstElementChild.getAttribute("name"))
	    return this.el.firstElementChild.getAttribute("name")	    
	},
	blockquoteShow() {
	    for( let c of this.custom)
		if( c.value == this.selected)
		    return true
	}
    },
    methods: {
	text(c) {
	    return $(c).html()
	},
	/* changed(event) {
	    this.$store.dispatch("checkPrice")
	} */
    },
    updated() {
	if(this.$store.state.customSelectChanged) {
	    //console.log("customSelect changed...checkPrice")
	    // transition bounceの分だけ処理を遅らせる必要がある
	    //  => 安定しないのでやめた
	    //const checkPricef = () => {
		this.$store.dispatch("checkPrice")
	    //}
	    //setTimeout(checkPricef, 530)
	    this.$store.commit('customSelectChange',false)
	}
    },
    beforeMount() {
	//console.debug(this.simpleEl)
	//SimpleEl.name = 'simple-element'
	/*
	const option = $(this.el.firstElementChild).children()
	this.opt = []
	for(let i=0; i<option.length; i++) {
	    //option[i].getAttribute('value')
	    this.opt.push({
		value: option[i].getAttribute('value'),
		text: $(option[i]).text()
	    })
	    if(i==0) this.selected = option[i].getAttribute('value')
	}
	*/
	//console.log(this.opt)
	
	//const div = $(this.el).find("blockquote div")
	const div = $(this.el).children("blockquote").children("div")
	this.custom = []
	for(let i=0; i<div.length; i++) {
	    //console.log(div[i])
	    this.custom.push({
		value: div[i].getAttribute('value'),
		el: div[i]
	    })
	}
	//console.log(this.sel_name, this.custom)
    },
    components: {
      // simple-elementを登録する必要があるが、
      // ここに記述しようとすると循環参照になってしまう為、
      // 呼び出し元のSimpleElemnt.js内で追加する。
    },
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}  

.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-out .5s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce-out {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(0);
  }
}
</style>



// WEBPACK FOOTER //
// CustomSelect.vue?886bad60